import { render, staticRenderFns } from "./caseShow.vue?vue&type=template&id=57de092e&scoped=true&"
import script from "./caseShow.vue?vue&type=script&lang=js&"
export * from "./caseShow.vue?vue&type=script&lang=js&"
import style0 from "./caseShow.vue?vue&type=style&index=0&id=57de092e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57de092e",
  null
  
)

export default component.exports